// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../NodeCache/metalyx/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../NodeCache/metalyx/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Color Palette — Metalyx Brand */
  --color-bg-primary:     #0A0E1A;
  --color-bg-secondary:   #111827;
  --color-bg-card:        #1E293B;
  --color-bg-card-hover:  #334155;

  --color-text-primary:   #CBD5E1;
  --color-text-heading:   #FFFFFF;
  --color-text-muted:     #64748B;

  --color-accent:         #7C3AED;
  --color-accent-hover:   #6D28D9;
  --color-accent-glow:    rgba(124, 58, 237, 0.15);

  --color-metalyx:        #7C3AED;
  --color-metalyx-hover:  #6D28D9;
  --color-metalyx-glow:   rgba(124, 58, 237, 0.15);
  --color-metalyx-light:  #C4B5FD;

  --color-electric:       #3B82F6;
  --color-violet:         #8B5CF6;
  --color-amber:          #F59E0B;
  --color-coral:          #EF4444;

  --color-border:         rgba(255, 255, 255, 0.06);

  /* Typography */
  --font-heading: 'Outfit', sans-serif;
  --font-sans:    'DM Sans', sans-serif;
  --font-mono:    'Space Mono', monospace;

  --text-xs:   0.75rem;
  --text-sm:   0.875rem;
  --text-base: 1rem;
  --text-lg:   1.125rem;
  --text-xl:   1.25rem;
  --text-2xl:  1.5rem;
  --text-3xl:  1.875rem;
  --text-4xl:  2.25rem;
  --text-5xl:  3rem;
  --text-6xl:  3.75rem;

  /* Spacing */
  --space-section:   6rem;
  --space-container: clamp(1rem, 5vw, 6rem);
  --max-width:       1200px;

  /* Effects */
  --radius-sm:  0.375rem;
  --radius-md:  0.75rem;
  --radius-lg:  1rem;
  --shadow-card: 0 4px 24px rgba(0, 0, 0, 0.3);
  --transition:  200ms ease;
}

*, *::before, *::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: var(--font-sans);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gDAAgD;;EAEhD,+BAA+B;EAC/B,+BAA+B;EAC/B,gDAAgD;EAChD,+BAA+B;;EAE/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,iDAAiD;;EAEjD,eAAe;EACf,oCAAoC;EACpC,qCAAqC;EACrC,uCAAuC;;EAEvC,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;;EAEpB,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;;EAEzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qCAAqC;IACrC,sCAAsC;EACxC;AACF","sourcesContent":[":root {\n  /* Color Palette — Metalyx Brand */\n  --color-bg-primary:     #0A0E1A;\n  --color-bg-secondary:   #111827;\n  --color-bg-card:        #1E293B;\n  --color-bg-card-hover:  #334155;\n\n  --color-text-primary:   #CBD5E1;\n  --color-text-heading:   #FFFFFF;\n  --color-text-muted:     #64748B;\n\n  --color-accent:         #7C3AED;\n  --color-accent-hover:   #6D28D9;\n  --color-accent-glow:    rgba(124, 58, 237, 0.15);\n\n  --color-metalyx:        #7C3AED;\n  --color-metalyx-hover:  #6D28D9;\n  --color-metalyx-glow:   rgba(124, 58, 237, 0.15);\n  --color-metalyx-light:  #C4B5FD;\n\n  --color-electric:       #3B82F6;\n  --color-violet:         #8B5CF6;\n  --color-amber:          #F59E0B;\n  --color-coral:          #EF4444;\n\n  --color-border:         rgba(255, 255, 255, 0.06);\n\n  /* Typography */\n  --font-heading: 'Outfit', sans-serif;\n  --font-sans:    'DM Sans', sans-serif;\n  --font-mono:    'Space Mono', monospace;\n\n  --text-xs:   0.75rem;\n  --text-sm:   0.875rem;\n  --text-base: 1rem;\n  --text-lg:   1.125rem;\n  --text-xl:   1.25rem;\n  --text-2xl:  1.5rem;\n  --text-3xl:  1.875rem;\n  --text-4xl:  2.25rem;\n  --text-5xl:  3rem;\n  --text-6xl:  3.75rem;\n\n  /* Spacing */\n  --space-section:   6rem;\n  --space-container: clamp(1rem, 5vw, 6rem);\n  --max-width:       1200px;\n\n  /* Effects */\n  --radius-sm:  0.375rem;\n  --radius-md:  0.75rem;\n  --radius-lg:  1rem;\n  --shadow-card: 0 4px 24px rgba(0, 0, 0, 0.3);\n  --transition:  200ms ease;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-sans);\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    transition-duration: 0.01ms !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
